import { faSignOut } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Link } from 'react-router-dom'
import { ROUTES } from '../../constants/routes'
import { useAuth } from '../../hooks/useAuth'
import { useToast } from '../../hooks/useToast'
import { CommandMenu } from '../CommandMenu/CommandMenu'
import { ProvideCommandMenuOpen } from '../CommandMenu/hooks/useCommandMenuOpen'
import { ErrorContent } from '../ErrorContent/ErrorContent'
import { Toast } from '../Toast/Toast'
import { MainContentSkeleton } from './components/LayoutSkeleton'
import { SideNav } from './components/SideNav'
import { useProvideDashboard } from './hooks/useDashboard'

interface IProps {
  isLoading?: boolean
  isWide?: boolean
}

export const DashboardLayout = ({
  children,
  isWide: initialIsWide = false,
}: React.PropsWithChildren<IProps>): React.ReactElement => {
  const { isWide } = useProvideDashboard({ isWide: initialIsWide })
  const authProps = useAuth()
  const { toast } = useToast()

  return (
    <div className="dashboard">
      <ProvideCommandMenuOpen>
        <SideNav {...authProps} />
        {toast ? <Toast {...toast} /> : null}
        {!authProps.user || !authProps.member || authProps.isSwitching ? (
          <MainContentSkeleton>
            {authProps.member || authProps.isSwitching ? (
              children
            ) : (
              <ErrorContent
                style={{ marginTop: '7.5rem' }}
                error={{
                  code: 401,
                  message:
                    'Looks like there are no programs associated to this account. Try logging out and logging into another account. If there appears to be an issue please contact our support for assistance.',
                  timestamp: new Date().toJSON(),
                }}
              >
                <Link className="btn btn-outline-primary" to={ROUTES.LOGOUT}>
                  <FontAwesomeIcon className="me-2" icon={faSignOut} />
                  Logout
                </Link>
              </ErrorContent>
            )}
          </MainContentSkeleton>
        ) : (
          <div className="main-content">
            {!isWide ? (
              <div className="container-fluid py-2" style={{ minHeight: '100vh' }}>
                {children}
              </div>
            ) : (
              children
            )}
            <CommandMenu />
          </div>
        )}
      </ProvideCommandMenuOpen>
    </div>
  )
}
